import styled from 'styled-components';
import BaseButton from './baseButton';

export const NeutralButton = styled(BaseButton)`
  background-color: ${({ theme }) => theme.buttons.neutralButton.default.background};
  color: ${({ theme }) => theme.buttons.neutralButton.default.font};
  &:hover {
    background-color: ${({ theme }) => theme.buttons.neutralButton.hovered.background};
  }
  &:focus {
    background-color: ${({ theme }) => theme.buttons.neutralButton.focused.background};
    color: ${({ theme }) => theme.buttons.neutralButton.focused.font};
  }
  &:disabled {
    cursor: not-allowed;
    color: ${({ theme }) => theme.buttons.neutralButton.disabled.font};
    background-color: ${({ theme }) => theme.buttons.neutralButton.disabled.background};
  }
`;
